import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getRolePermissionsByIdAsync, updateRolePermissionAsync } from '@application/features/rolepermission/rolepermissionThunk';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import VnButton from '@ui/components/VnButton';
import VnValidation from '@ui/components/VnValidation';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import UpdateRolePermissionTable from './UpdateRolePermissionTable';
import Select from 'react-select';
import { selectStyles } from '@ui/styles/select-style';
import { RoleCategory, RoleCategoryMap } from '@application/common/enums/role-category';
const UpdateRolePermissionForm = ({ onClose, roleId }) => {
    const dispatch = useAppDispatch();
    const { roles } = useAppSelector((state) => state.auth);
    const [updatedRolePermissions, setUpdatedRolePermissions] = useState([]);
    const roleCategoryList = [];
    const [roleCategoryType, setRoleCategoryType] = useState(roleCategoryList[0]);
    const { setValue, handleSubmit, register, clearErrors, control, formState: { errors } } = useForm({
        defaultValues: {}
    });
    Object.keys(RoleCategory)
        .filter((v) => isNaN(Number(v)))
        .forEach((key, index) => {
        roleCategoryList.push({ label: RoleCategoryMap.get(index), value: index.toString() });
    });
    useEffect(() => {
        dispatch(getRolePermissionsByIdAsync(roleId))
            .unwrap()
            .then((data) => {
            setUpdatedRolePermissions(data);
            if (data.length > 0) {
                setRoleCategoryType(roleCategoryList[data[0].roleCategoryId ?? 0]);
            }
        });
        const selectedRole = roles?.find((x) => x.id === roleId);
        if (selectedRole && selectedRole.description) {
            setValue('roleId', roleId);
            setValue('roleDescription', selectedRole.description);
        }
    }, [dispatch, roleId, roles, setValue]);
    function updateRolePermission(id, newPermissionType, isChecked) {
        let updatedPermissions = updatedRolePermissions.map((rolePermission) => {
            if (rolePermission.id === id) {
                switch (newPermissionType) {
                    case PermissionType.Create:
                        if (isChecked) {
                            return {
                                ...rolePermission,
                                create: isChecked,
                                read: isChecked,
                                update: isChecked
                            };
                        }
                        else {
                            return {
                                ...rolePermission,
                                create: isChecked,
                                read: isChecked,
                                update: isChecked
                            };
                        }
                    case PermissionType.Read:
                        return { ...rolePermission, read: isChecked };
                    case PermissionType.Update:
                        if (isChecked) {
                            return {
                                ...rolePermission,
                                create: isChecked,
                                read: isChecked,
                                update: isChecked
                            };
                        }
                        else {
                            return {
                                ...rolePermission,
                                create: isChecked,
                                read: isChecked,
                                update: isChecked
                            };
                        }
                    case PermissionType.Delete:
                        if (isChecked) {
                            return {
                                ...rolePermission,
                                create: isChecked,
                                read: isChecked,
                                update: isChecked,
                                delete: isChecked
                            };
                        }
                        else {
                            return {
                                ...rolePermission,
                                create: isChecked,
                                read: isChecked,
                                update: isChecked,
                                delete: isChecked
                            };
                        }
                    default:
                        return rolePermission;
                }
            }
            // else if (rolePermission.id === id && rolePermission.permission?.parentId) {
            //     switch (newPermissionType) {
            //         case PermissionType.Create:
            //             return { ...rolePermission, create: isChecked };
            //         case PermissionType.Read:
            //             return { ...rolePermission, read: isChecked };
            //         case PermissionType.Update:
            //             return { ...rolePermission, update: isChecked };
            //         case PermissionType.Delete:
            //             return { ...rolePermission, delete: isChecked };
            //         default:
            //             return rolePermission;
            //     }
            // }
            return rolePermission;
        });
        const currentItem = updatedPermissions.filter((x) => x.id === id);
        const updatePermissionschildren = updatedPermissions.map((rolepermission) => {
            if (rolepermission.permission?.parentId === currentItem[0].permissionId) {
                switch (newPermissionType) {
                    case PermissionType.Create:
                        return { ...rolepermission, read: isChecked, create: isChecked, update: isChecked };
                    case PermissionType.Read:
                        return { ...rolepermission, read: isChecked };
                    case PermissionType.Update:
                        return { ...rolepermission, read: isChecked, create: isChecked, update: isChecked };
                    case PermissionType.Delete:
                        return { ...rolepermission, read: isChecked, create: isChecked, update: isChecked, delete: isChecked };
                    default:
                        return rolepermission;
                }
            }
            return rolepermission;
        });
        const updateWorkOrderPermissions = updatePermissionschildren.map((rolepermission) => {
            if (rolepermission.permission?.id === Permission.WERKORDER) {
                return { ...rolepermission, read: true };
            }
            else if (rolepermission.id === id && rolepermission.permission?.id === Permission.BEHEER) {
                return { ...rolepermission, read: isChecked, create: isChecked, update: isChecked, delete: isChecked };
            }
            else if (rolepermission.id === id && rolepermission.permission?.id === Permission.WPPLANNING) {
                return { ...rolepermission, read: isChecked, create: isChecked, update: isChecked, delete: isChecked };
            }
            return rolepermission;
        });
        const disableParentonDeleteIfChildDeleteDisabled = updateWorkOrderPermissions.map((rolepermission) => {
            if (rolepermission?.permissionId === currentItem[0].permission?.parentId) {
                switch (newPermissionType) {
                    case PermissionType.Delete:
                        return { ...rolepermission, delete: false };
                    default:
                        return rolepermission;
                }
            }
            return rolepermission;
        });
        setUpdatedRolePermissions(disableParentonDeleteIfChildDeleteDisabled);
    }
    const handleRoleCategoryChange = (option) => {
        setRoleCategoryType(option);
    };
    const onSubmit = (data) => {
        data.rolePermission = updatedRolePermissions;
        data.roleCategoryId = parseInt(roleCategoryType.value);
        dispatch(updateRolePermissionAsync(data))
            .unwrap()
            .then(() => {
            onClose();
        });
    };
    return (_jsx(_Fragment, { children: _jsx("div", { className: 'mt-4', children: _jsxs("form", { onSubmit: handleSubmit(onSubmit), className: 'Vn-form-FormMain', noValidate: true, children: [_jsxs("div", { className: 'row', children: [_jsxs("div", { className: 'col-sm-8 col-md-8', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Rolnaam" }), _jsx("input", { type: 'text', className: 'form-control vn-Input', placeholder: 'Voer voornaam in', ...register('roleDescription', {
                                            required: 'Dit veld is verplicht'
                                        }) }), _jsx(VnValidation, { fieldError: errors.roleDescription })] }), _jsxs("div", { className: 'col-sm-4 col-md-4', style: { zIndex: 10 }, children: [_jsx("label", { className: 'form-label vn-text-label', children: "Rol Categorie" }), _jsx(Controller, { name: 'roleCategoryId', control: control, 
                                        // rules={{ required: 'Dit veld is verplicht' }}
                                        render: ({ field: { onChange, value } }) => (_jsx(Select, { placeholder: 'Select Rol Categorie', isSearchable: false, styles: selectStyles, value: roleCategoryType, options: roleCategoryList, onChange: (selectedValue) => {
                                                handleRoleCategoryChange(selectedValue);
                                            } })) })] })] }), _jsx("br", {}), updatedRolePermissions && (_jsx(_Fragment, { children: _jsx(UpdateRolePermissionTable, { rolePermissions: updatedRolePermissions, updateRolePermission: updateRolePermission }) })), _jsx("div", { className: 'vn-Form_Footer mt-4', children: _jsxs("div", { style: { display: 'flex', marginLeft: 'auto' }, children: [_jsx(VnButton, { customClassName: 'Vn-cancel-button', mode: 'secondary', onClick: onClose, type: 'button', children: "Annuleren" }), _jsx(VnButton, { customClassName: 'Vn-save-button vn-popup-save-button', mode: 'primary', type: 'submit', children: "Opslaan" })] }) })] }) }) }));
};
export default UpdateRolePermissionForm;
